import alertModel from '../../../components/Dialogs/alertModal';

export default {
  name: 'Ratings',
  props: ['portfolioData', 'rankingLastRow'],
  components: { alertModel },
  data() {
    return {
      showAlert: false,
    };
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    getIntFormat(value) {
      if (
        isNaN(value)
        || value == 0
        || value == '-'
        || value == null
        || value == ''
      ) {
        return '-';
      }
      return this.formatNumber(parseFloat(value).toFixed(0));
    },
    popUpMsg(msg) {
      this.showAlert = true;
      this.message = msg;
    },
    cancelModal() {
      this.showAlert = false;
    },
    getTextClass(column, value) {
      let colorclass;
      if (column === 'MasterScore' || column === 'AD_Rating') {
        if (value.includes('D') || value.includes('E')) colorclass = 'redText';
        else if (value.includes('C')) colorclass = 'orangeText';
        else if (value.includes('A') || value.includes('B')) colorclass = 'greenText';
        else colorclass = '';
      } else if (column === 'CanslimScore' || column === 'EPS_Rank' || column === 'RS_Rank') {
        if (value >= 80) colorclass = 'greenText';
        else if (value < 80 && value >= 60) colorclass = 'orangeText';
        else if (value < 60) colorclass = 'redText';
        else colorclass = '';
      } else if (column === 'Group_Rank') {
        if (value > 80) colorclass = 'redText';
        else if (value <= 80 && value >= 41) colorclass = 'orangeText';
        else if (value < 40 && value >= 1) colorclass = 'greenText';
        else colorclass = '';
      }
      return colorclass;
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/Report/Ratings.js